<template>
  <div class="formulate-input">
    <label
      v-if="labelText"
      class="formulate-input-label mb-2"
      :for="id"
    >
      <small
        v-show="isRequired"
        class="text-danger"
      >
        *
      </small>
      {{ labelText }}</label
    >
    <v-select
      :value="computedValue"
      @input="updateLocalValue"
      :id="id"
      :label="labelOption"
      :options="orderAlphabetically(options)"
      :placeholder="placeholder"
      :multiple="multiple"
      :reduce="multiple ? (option => option.value) : undefined"
      :required="isRequired"
      :disabled="isDisabled"
    >
      <template v-slot:no-options>Nenhum item encontrado.</template>
    </v-select>
  </div>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
export default {
  name: 'NxSelect',
  mixins: [useReactiveModelMixin('value')],
  props: {
    options: {
      type: Array,
      required: true,
      default: null
    },
    labelOption: {
      type: String,
      required: false,
      default: 'text'
    },
    labelText: {
      type: String,
      required: false,
      default: 'Selecione:'
    },
    id: {
      type: String,
      required: true,
      default: null
    },
    placeholder: {
      type: String,
      required: true,
      default: null
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    computedValue () {
      // Se não tem valor, retorna null
      if (!this.localValue) {
        return null
      }

      // Quando está em modo múltiplo e temos apenas valores (IDs), precisa converter para objetos
      if (this.multiple && Array.isArray(this.localValue) && this.localValue.length > 0) {
        // Verifica se já são objetos ou são valores primitivos
        if (typeof this.localValue[0] === 'object' && this.localValue[0] !== null) {
          return this.localValue
        }
        // Se são valores primitivos, encontra os objetos correspondentes nas opções
        return this.localValue.map(val => {
          const found = this.options.find(opt => opt.value === val)
          return found || null
        }).filter(opt => opt !== null)
      }

      // Quando não está em modo múltiplo, se for valor primitivo, encontra o objeto correspondente
      if (!this.multiple && typeof this.localValue !== 'object') {
        const found = this.options.find(opt => opt.value === this.localValue)
        return found || null
      }

      // Se já é um objeto, retorna como está
      return this.localValue
    }
  },
  created () {
    this.$root.$on('clearForm', () => {
      this.localValue = null
    })
  },
  methods: {
    orderAlphabetically (list) {
      let options = list
      let optionsLabel = this.labelOption

      return options
        .slice()
        .sort((a, b) => a[optionsLabel].localeCompare(b[optionsLabel]))
    },
    updateLocalValue (newValue) {
      // Em modo múltiplo, o reduce está ativo, então retorna apenas os values
      if (this.multiple && Array.isArray(newValue)) {
        this.localValue = newValue.map(v => (v && typeof v === 'object' && v.hasOwnProperty('value') ? v.value : v))
      } else if (!this.multiple && newValue && typeof newValue === 'object' && newValue !== null && newValue.hasOwnProperty('value')) {
        // Em modo único SEM reduce, o v-select retorna o objeto completo, então extrai o value
        this.localValue = newValue.value
      } else {
        // Caso contrário, usa o valor como está
        this.localValue = newValue
      }
    }
  }
}
</script>
<style lang="scss">
.formulate-input {
  li {
    text-transform: uppercase !important;
  }
}
.v-select.vs--open {
  .vs__dropdown-toggle {
    outline: 0;
    border: 1px solid #41b883;
  }
}

.v-select {
  .vs__dropdown-toggle {
    min-height: 2.2rem;
    padding: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/selects/NxSelect.vue